interface StatusDotProps {
  color?: string;
  pulse?: boolean;
}

export function StatusDot({ color = 'var(--success)', pulse }: StatusDotProps) {
  return (
    <span style={{ position: 'relative', display: 'inline-flex', width: 8, height: 8 }}>
      <span
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: 99,
          background: color,
          animation: pulse ? 'pulse-dot 2s infinite' : 'none'
        }}
      />
    </span>
  );
}
